<div class="wrapper mb-2">
    <div class="row title-container align-items-center mb-4" style="padding: 10px;">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Meus Produtos</span>
        <button class="action-button" (click)="newContrato()">Aderir novo produto</button>
    </div>
    <mat-drawer-container class="drawer-container" (backdropClick)="close()" hasBackdrop="true">
        <mat-drawer #drawer mode="over" position="end" (keydown.escape)="close()" class="drawer">
            <div class="container mb-5 mt-2 dcontainer">
                <h5 class="modal-title clean-modal-title text-center" style="font-size: 20px;">
                    Valores Padrões do Produto {{contractAssignorToUpdate != undefined ? contractAssignorToUpdate.productEligibility.product.descricaoProduto : ''}}
                </h5>
                <form [formGroup]="updateContratoForm" (ngSubmit)="onSubmit(updateContratoForm.value)" #contratoForm="ngForm">
                    <div class="form-group">
                        <label for="valorPadrao" class="clean-modal-section-title ">Valor Padrão <b style="color:red">*</b></label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">R$</span>
                            </div>
                            <input formControlName="valorPadrao" type="number" id="valorPadrao" required min="1"  [ngClass]="{'is-invalid':inValorPadraoInvalid}" class="input-border-botton form-control" [value]="" />
                        </div>
                    </div>
                    <div *ngIf="form.valorPadrao.invalid && (form.valorPadrao.dirty || form.valorPadrao.touched)"
                        class="invalid-feedback">
                        <div *ngIf="form.valorPadrao.errors.required">
                            Você deve definir um valor padrão!
                        </div>
                        <div *ngIf="form.valorPadrao.errors.min">
                            O valor padrão deve ser maior que zero!
                        </div>
                    </div>
                    <span class="" *ngIf="inValorPadraoInvalid">
                        {{messageValorPadrao}}
                    </span>

                    <div class="form-group">
                        <label for="cartaoPeriodoPadraoId" class="clean-modal-section-title ">Período Padrão <b style="color:red">*</b></label>
                        <select *ngIf="!hasStandardPeriod" formControlName="cartaoPeriodoPadraoId" id="cartaoPeriodoPadraoId" class="form-control">
                            <option *ngFor="let item of cartaoPeriodosPadroes" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</option>
                        </select>
                        <select *ngIf="hasStandardPeriod" formControlName="cartaoPeriodoPadraoId" id="cartaoPeriodoPadraoId" class="form-control">
                            <option [value]="contractAssignorToUpdate.standardPeriodId">{{produtoPeriodoPadrao}}</option>
                        </select>
                    </div>
                    <div *ngIf="form.cartaoPeriodoPadraoId.invalid && (form.cartaoPeriodoPadraoId.dirty || form.cartaoPeriodoPadraoId.touched)"
                        class="invalid-feedback">
                        <div *ngIf="form.cartaoPeriodoPadraoId.errors.required">
                            Você deve definir um período padrão!
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="clean-modal-section-title ">É editável</div>
                        <div class="form-group">
                            <input formControlName="ehEditavel" id="ehEditavel" class="rdButton mx-2" type="checkbox" (change)="ehEditavelCheck($event,modalEhEditavel)"/>
                            <label for="ehEditavel" class="form-check-label"></label>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="clean-modal-section-title ">Priorizar produto</div>
                        <div class="form-group">
                            <input formControlName="priorizado" id="priorizado" class="rdButton mx-2" type="checkbox">
                            <label for="priorizado" class="form-check-label"></label>
                        </div>
                    </div>

                    <!-- <div class="form-group">
                        <label for="valorMaximoBaneficio" class="clean-modal-section-title ">Valor Máximo do Produto</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">R$</span>
                            </div>
                            <input formControlName="valorMaximoBeneficio" type="number" id="valorMaximoBaneficio" [ngClass]="{'is-invalid':inValorMaximoInvalid}" class="form-control" [value]="" />
                        </div>
                    </div>
                    <span class="invalid-feedback" *ngIf="inValorMaximoInvalid">
                        {{messageValorMaximo}}
                    </span> -->

                    <div class="form-group" *ngIf="permitirValorIncremento">
                        <label for="valorIncremento" class="clean-modal-section-title ">Valor de Incremento</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">R$</span>
                            </div>
                            <input formControlName="valorIncremento" type="number" id="valorIncremento" [ngClass]="{'is-invalid':inValorIncrementoInvalid}" class="form-control" [value]=""  />
                        </div>
                    </div>
                    <span class="invalid-feedback" *ngIf="inValorIncrementoInvalid && permitirValorIncremento">
                        {{messageValorIncremento}}
                    </span>

                    <div class="col-12 mt-3">
                        <div class="col-md 6 col-sm-12 row justify-content-center pr-0">
                            <button class="custom-filter-button button-cancel w-75" type="button" (click)="drawer.toggle();">Cancelar</button>
                        </div>
                        <div class="col-md- 6 col-sm-12 row justify-content-center pr-0">
                            <button class="custom-filter-button button-color-just w-75 mt-2" type="submit" [disabled]="!updateContratoForm.valid">Confirmar</button>
                        </div>
                    </div>
                </form>
                <div class="m-3">
                    <p class="text-justify">Nesta tela, informe o valor padrão e a periodicidade que deseja distribuir aos seus favorecidos neste produto. Fique tranquilo,  são apenas valores usados como referência, você poderá depois determinar o valor e periodicidade para cada favorecido que incluir na plataforma.
                        <br>
                        Informe se o valor definido poderá ser editável ou não, assim, você terá maior tranquilidade ao editar posteriormente os valores determinados aos favorecidos.
                        <br>
                        <span *ngIf="permitirValorIncremento">
                            Opcionalmente, você ainda poderá determinar um valor máximo que um favorecido poderá ter em sua configuração e poderá também determinar um valor de incremento, valor este que será utilizado no momento da distribuição de créditos, respeitando o valor máximo para distribuição caso exista.
                        </span>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content>
            <div class="header-escolha row mt-3">
                <div class="header-margin row">
                    <div class="header-separar row">
                        <div *ngFor="let item of produtoCategoria">
                            <div class="header-item">
                                <input value="{{item.id}}" type="radio" name="tipo-beneficio"
                                    id="{{item.id}}" (change)="changeCategory($event)" [checked]="item.id == 1 ? true : '' ">
                                <label for="{{item.id}}" class="form-check-label font-weight-normal header-item-descricao">{{item.categoryAssignorLabel}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-box container-fluid">
                <!--            Validação de cedente sem contrato -->
                <div class="container-fluid pt-5 pb-2 pl-4">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="row h-100">
                                <input class="list-header-search-input" type="search" placeholder="Pesquise aqui..." [(ngModel)]="filtroPesquisa" (input)="searchFilter()" />
                                <div class="list-show-item ml-5">Mostrar:
                                    <select [(ngModel)]="showItem">
                                        <option [ngValue]="10" value="10">10</option>
                                        <option [ngValue]="25" value="25" selected>25</option>
                                        <option [ngValue]="50" value="50">50</option>
                                        <option [ngValue]=100 value="100">100</option>
                                    </select>
                                </div>
                                <div class="list-pagination ml-2">
                                    <pagination-controls (pageChange)="currentPage=$event" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="isEmpty">
                        <p class="text-center form-title">{{messageErro}}</p>
                    </div>
                    <div class="custom-col-produto" *ngFor="let cedenteContrato of contractAssignorList | paginate: { itemsPerPage: showItem, currentPage: currentPage }">
                        <div class="p-2 m-2">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                    <div class="card-img-top clickable" (click)="showConfigValores(cedenteContrato)">
                                        <app-svg-card [color]="cedenteContrato.productEligibility.product.corProduto" [icon]="cedenteContrato.productEligibility.product.iconeProduto" [name]="cedenteContrato.productEligibility.product.descricaoProduto"></app-svg-card>
                                    </div>
                                    <!--img [src]="'./assets/icons/produtos/icon-produtos/'+ cedenteContrato.productEligibility.product.produtoGuid +'.svg'" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';" class="card-img-top clickable" alt="{{cedenteContrato.productEligibility.product.descricao}}" (click)="showConfigValores(cedenteContrato)"/-->
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
                                    <p class="card-title">{{cedenteContrato.productEligibility.product.descricao}}</p>
                                    <p class="card-subtitle">{{cedenteContrato.productEligibility.product.importante}}</p>
                                    <p class="card-subtitle mt-2" *ngIf="cedenteContrato.feeValue > 0 && !cedenteContrato.isPercentage">Taxa administrativa: {{cedenteContrato.feeValue | currency: 'BRL' : true}}</p>
                                    <p class="card-subtitle mt-2" *ngIf="cedenteContrato.feeValue > 0 && cedenteContrato.isPercentage">Taxa administrativa: {{cedenteContrato.feeValue}}%</p>
                                    <p class="card-subtitle mt-2">Data de adesão:<br>{{cedenteContrato.createDate | date: "dd/MM/yyyy"}}</p>
                                </div>
                                <!-- <button (click)="cancelContrato(cedenteContrato.productEligibility.productElegibilidadeId)">a</button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>

<ng-template #termo let-modal>
    <div class="row px-4 text-center template" *ngIf="termoUso">
        <div class="col-12 my-2">
            <p class="title">Termos de Uso</p>
        </div>
        <div class="col-12 my-2">
            <iframe class="custom-termo" [src]="termoUso.url | safe"></iframe>
        </div>
        <div class="col-12 my-2">
            <button type="button" (click)="modal.dismiss('Close click')" class="button">Fechar</button>
        </div>
    </div>
</ng-template>

<!--Modal do QR Code-->
<!--
<ng-template #modalValores let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title text-center">
                Valores Padrões do Incentivo {{cedenteContratoToUpdade.productEligibility.product.descricao}}
            </h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="form-group">
            <label for="valorPadrao" class="clean-modal-section-title ">Valor Padrão (R$)</label>
            <input type="number" id="valorPadrao" #valorPadrao required min="1" class="input-border-botton form-control" [ngModel]="cedenteContratoToUpdade.valorPadrao" />
        </div>

        <div class="form-group">
            <label for="periodoPadrao" class="clean-modal-section-title ">Período Padrão</label>
            <select #periodoPadrao id="periodoPadrao" class="form-control" [ngModel]="cedenteContratoToUpdade.cartaoPeriodoPadraoId">
                <option *ngFor="let item of cartaoPeriodosPadroes" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}
                </option>
            </select>
        </div>

        <div class="form-group">
            <div class="clean-modal-section-title ">É editável</div>
            <div class="form-group">
                <input #ehEditavel id="ehEditavel" class="rdButton mx-2" type="checkbox"
                    [ngModel]="cedenteContratoToUpdade.ehEditavel" />
                <label for="ehEditavel" class="form-check-label">
                </label>
            </div>

        </div>

        <div class="form-group">
            <label for="valorMaximoBaneficio" class="clean-modal-section-title ">Valor Máximo do Incentivo (R$)</label>
            <input type="number" id="valorMaximoBaneficio" #valorMaximoBaneficio required min="1"
                class="form-control" [ngModel]="cedenteContratoToUpdade.valorMaximoBeneficio" />
        </div>

        <div class="form-group">
            <label for="valorIncremento" class="clean-modal-section-title ">Valor de Incremento (R$)</label>
            <input type="number" id="valorIncremento" #valorIncremento required min="1" class="form-control"
                [ngModel]="cedenteContratoToUpdade.valorIncremento" />
        </div>
    </div>
    <div class="col-12 my-2 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')"> Cancelar
        </button>
        <button class="custom-filter-button button-color-just" type="button" (click)="updateContrato(valorPadrao.value, periodoPadrao.value, ehEditavel.checked, valorMaximoBaneficio.value, valorIncremento.value)">
            Confirmar
        </button>
    </div>
</ng-template>
-->
<ng-template #modalEhEditavel let-modal>
        <div class="col-12 clean-modal-content">
        <p class="modal-title clean-modal-title text-center">
            Ao tornar este produto NÃO editável, os valores que já foram pré-definidos aos favorecidos que possuem este produto serão automaticamente substituídos pelo valor padrão.
            <br>
            <br>
            Confirma esta operação?
        </p>
    </div>
    <div class="col-12 my-2 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="onCancel()"> Cancelar
        </button>
        <button class="custom-filter-button button-color-just" type="button" (click)="onConfirm();">
            Confirmar
        </button>
    </div>
</ng-template>
